export default "__VITE_ASSET__BXnMQ2yX__"